import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
import UserProfilePage from './pages/UserProfilePage';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Login from './components/Authentication/Login';
import Register from './components/Authentication/Register';
import NewHomePage from './pages/NewHomePage';
import FavoritesPage from './pages/FavoritesPage';
import Config from './pages/ConfigPage'
import TornadoPage from './pages/TornadoPage';
import HealthCheck from './pages/HealthCheckPage';
import AdminPanel from './pages/AdminPanel';
import AchievementsPage from './pages/AchievementsPage';
import BoardEditorPage from './pages/BoardEditorPage';
import ForecastsPage from './pages/ForecastsPage';
import { isRegistrationEnabled } from './config/featureFlags';
import usePublicSections from './hooks/usePublicSections';


function AppRoutes() {
  const sections = usePublicSections();

  return (
      <Router>
        <div className="flex flex-col min-h-screen bg-white">
          <Header sections={sections} />
          <main className="flex-grow container mx-auto px-4 py-8">
            <Switch>
              <Route exact path="/" component={HomePage} />
              <Route path="/dashboard" component={NewHomePage} />
              <Route path="/favorites" component={FavoritesPage} />
              <Route path="/profile" component={UserProfilePage} />
              <Route path="/login" component={Login} />
              {isRegistrationEnabled() && <Route path="/register" component={Register} />}
              <Route path="/config" component={Config} />
              <Route path="/tornado" component={TornadoPage} />
              <Route path="/health" component={HealthCheck} />
              {sections.forecasts !== false && <Route path="/forecasts" component={ForecastsPage} />}
              <Route path="/admin" component={AdminPanel} />
              {sections.achievements !== false && <Route path="/achievements/board" component={BoardEditorPage} />}
              {sections.achievements !== false && <Route path="/achievements" component={AchievementsPage} />}
              {/* {(process.env.REACT_APP_API_BASE_URL || '').includes("localhost") && ( */}
              {/* <Route path="/debug-panel" component={DebugPanel} /> */}
              {/* )} */}
              <Redirect to="/" />
            </Switch>
          </main>
          <Footer />
        </div>
      </Router>
  );
}

// the section check needs AuthContext, so it lives one level below the provider
function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
